<template>
    <div>
        <div v-if="isGrouped" class="row">
            <div class="content-rv col-md-12 col-lg-12 col-xl-6">

                <!-- Disclaimer Renta Variable  inicio-->
                <div class="d-none d-xl-block">
                    <div class="fixed-bottom w-50 row mx-auto">
                        <div class="bg-white shadow-lg p-2 m-2 m-md-0 my-md-2 text-bat rounded-4">
                            <div class="row d-flex align-items-center justify-content-center">
                                <div class="col-2 d-flex align-items-center justify-content-end">
                                    <img src="/img-version2/icons/atention-msg.svg" alt="">
                                </div>
                                <div class="col-8">
                                    <p class="fw-bold mb-0 text-break fs-7 text-center">Este seguimiento de la renta variable es una herramienta de apoyo, <br> <span class="text-danger text-title-bat">no implica ningún compromiso de pago por parte de BAT</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Disclaimer Renta Variable  Final-->

                <div v-if="data_current_rv && data_current_rv.metrics && Object.keys(data_current_rv.metrics).length > 1">
                    <div class="row">
                        <div v-for="item in current_items" class="col-12 col-sm-12 col-md-12 col-lg-6">
                            <div class="card-var position-relative" :class="item.accelerator==1 ? 'accelerator' : item.accelerator==2 ? 'super-accelerator' :'no-accelerator'" style="height: 83px;">
                                <div class="wrapper-var">
                                    <div class="box box1">
                                        <div class="box-content">
                                            <p class="variable-name">{{ item.kpi }}</p>
                                            <input  class="input-number" type="number" v-model="item.real" @keyup="updateVariableData(item)" v-number-only />
                                            <el-progress class="variable-value" :percentage="(Number(item.advance) * 100) > 100 ? 100 : (Number(item.advance) * 100)" :show-text="false" :color="customColorMethodRV(item.advance, item.accelerator)"></el-progress>
                                            <p class="text-advance">({{ numberFormat(Math.round(item.advance * 10000) / 100) }}%)</p>
                                        </div>
                                    </div>
                                    <div class="box box2">
                                        <div class="box-content">
                                            <p class="rotulo">Objetivo</p>

                                            <p v-if="getTypeVariable(item.kpi)" class="valor">$ {{ numberFormat(item.goal) }}</p>
                                            <p v-else class="valor">{{ numberFormat(item.goal) }}</p>
                                        </div>
                                    </div>
                                    <div class="box box3">
                                        <div class="box-content">
                                            <p class="rotulo">Pendiente</p>
                                            <p v-if="(item.accelerator == 2) && (getTypeVariable(item.kpi) == true)" class="valor">
                                                $ {{ ((item.goal * (accelerators[1].value / 100)) - (item.real) <= 0) ? 0 : numberFormat(Number((item.goal * (accelerators[1].value / 100)) - item.real).toFixed(0)) }}
                                            </p>
                                            <p v-else-if="(item.accelerator == 2) && (getTypeVariable(item.kpi) == false)" class="valor">
                                                {{ ((item.goal * (accelerators[1].value / 100)) - (item.real) <= 0) ? 0 : numberFormat(Number((item.goal * (accelerators[1].value / 100)) - item.real).toFixed(0)) }}
                                            </p>
                                            <p v-else-if="(item.accelerator == 1) && (getTypeVariable(item.kpi) == true)" class="valor">
                                                $ {{ ((item.goal * (accelerators[0].value / 100)) - (item.real) <= 0) ? 0 : numberFormat(Number((item.goal * (accelerators[0].value / 100)) - item.real).toFixed(0)) }}
                                            </p>
                                            <p v-else-if="(item.accelerator == 1) && (getTypeVariable(item.kpi) == false)" class="valor">
                                                {{ ((item.goal * (accelerators[0].value / 100)) - (item.real) <= 0) ? 0 : numberFormat(Number((item.goal * (accelerators[0].value / 100)) - item.real).toFixed(0)) }}
                                            </p>
                                            <p v-else-if="(item.accelerator == 0) && (getTypeVariable(item.kpi) == true)" class="valor">
                                                $ {{ (item.goal - item.real <= 0) ? 0 : numberFormat(Number((item.goal - item.real).toFixed(0))) }}
                                            </p>
                                            <p v-else-if="(item.accelerator == 0) && (getTypeVariable(item.kpi) == false)" class="valor">{{ (item.goal - item.real <= 0) ? 0 : numberFormat(Number(item.goal - item.real).toFixed(0)) }}</p>
                                        </div>
                                    </div>
                                    <div class="box box4 position-relative">
                                        <div v-if="item.accelerator==1" class="position-absolute top-0 start-50 translate-middle">
                                            <img v-if="item.advance<0.9" src="/img-version2/icons/cohete-rojo.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                            <img v-else-if="item.advance>=0.9 && item.advance<1" src="/img-version2/icons/cohete-naranja.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                            <img v-else-if="item.advance>=1 && item.advance<1.1" src="/img-version2/icons/cohete-verde.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                            <img v-else-if="item.advance>=1.1" src="/img-version2/icons/cohete-azul.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                        </div>
                                        <div v-else-if="item.accelerator==2" class="position-absolute top-0 start-50 translate-middle">
                                            <img v-if="item.advance<0.9" src="/img-version2/icons/meteorito-rojo.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                            <img v-else-if="item.advance>=0.9 && item.advance<1" src="/img-version2/icons/meteorito-naranja.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                            <img v-else-if="item.advance>=1 && item.advance<1.2" src="/img-version2/icons/meteorito-verde.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                            <img v-else-if="item.advance>=1.2" src="/img-version2/icons/meteorito-morado.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                        </div>
                                        <div class="box-content">
                                            <p class="rotulo">Peso</p>
                                            <p class="valor">{{ Math.round(item.peso * 100) }}%</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="card-var position-relative">
                                <div class="wrapper-channels">
                                    <div class="box box1">
                                        <div class="box-content">
                                            <p class="variable-name p-2">Cumplimiento {{ active_tab }}</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <div class="box-content">
                                            <p v-if="active_tab == 'WHS'" class="valor p-2">{{numberFormat(Math.round(Number(whs_accomplishment) * 10000) / 100)}}%</p>
                                            <p v-if="active_tab == 'RETAIL'" class="valor p-2">{{numberFormat(Math.round(Number(retail_accomplishment) * 10000) / 100)}}%</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class=" col-12">
                            <button @click="restoreData()" class="btn btn-lg btn-block btn-apply w-100">Restaurar <i class="fa fa-arrow-rotate-left"></i></button>
                        </div>
                    </div>
                </div>

                <div v-if="showModalPopupsWildcard">
                    <popups-wildcard :closeModalWildcard="closeModalWildcard"></popups-wildcard>
                </div>
            </div>

            <!-- Velocimetro -->
            <div class="col-md-12 col-lg-12 col-xl-6">
                <div class="row velocimetro">
                    <!-- Candado de Cartera Final -->
                    <div class="container w-100 tacometro">
                        <div class="row justify-content-center">
                            <div class="col-md-10 col-lg-10">
                                <div class="d-flex justify-content-center flex-wrap content-margin">
                                    <div class="hidden-circle">
                                        <div class="skill">
                                            <div class="point" id="point" ref="point"></div>
                                            <div class="outer">
                                                <div class="inner">
                                                    <div class="number" id="number" ref="result_number">
                                                        <p v-if="rv_result">{{ rv_result }}</p>
                                                        <p v-else>{{ 0 }}</p>
                                                    </div>
                                                    <div class="text">
                                                        <p>Pago R.V </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <svg id="circle" xmlns="http://www.w3.org/2000/svg" version="1.1" width="374px" height="374px" ref="circle_simulator">
                                                <defs>
                                                    <linearGradient id="GradientColorSimulator">
                                                        <stop offset="0%" stop-color="" ref="stop1"></stop>
                                                        <stop offset="100%" stop-color="" ref="stop2"></stop>
                                                    </linearGradient>
                                                </defs>
                                                <circle id="circleIndicatorSimulator" cx="188" cy="188" r="170" stroke-linecap="round"></circle>
                                            </svg>

                                        </div>
                                    </div>
                                    <div class="col-12 text-variable d-flex justify-content-between">
                                        <p>0</p>
                                        <p class="disabled star" id="star" ref="star"> <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.2076 23.6022C14.3106 23.5397 14.4398 23.5397 14.5428 23.6022L20.0389 26.9352C21.7515 27.9738 23.8697 26.4395 23.4167 24.4884L21.9538 18.1876C21.9268 18.0711 21.9663 17.9492 22.0565 17.8706L26.9339 13.6252C28.4416 12.3128 27.6319 9.83314 25.6403 9.66336L19.2329 9.11715C19.1133 9.10696 19.0091 9.0313 18.9625 8.92068L16.4603 2.98879C15.6822 1.14412 13.0682 1.14412 12.2901 2.98879L9.78792 8.92068C9.74126 9.0313 9.63714 9.10696 9.51751 9.11715L3.11013 9.66336C1.11849 9.83314 0.30884 12.3128 1.81653 13.6252L6.69389 17.8706C6.78411 17.9492 6.8236 18.0711 6.79655 18.1876L5.33366 24.4884C4.88067 26.4395 6.99892 27.9738 8.71155 26.9352L14.2076 23.6022Z" fill="#EFEFEF" stroke="white" stroke-width="1.93975" />
                                            </svg>
                                            <span v-if="payments_rv && payments_rv.length > 0">{{ payments_rv[payments_rv.length - 1].rv_payment }}</span>
                                            <span v-else>150</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="content-bloq">
                        <div class="see-table d-flex justify-center mb-4">
                            <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#tableModalSimulator">
                                Ver tabla de conversión
                            </button>
                        </div>

                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                <div class="card-var">
                                    <div class="wrapper-channels-rv">
                                        <div class="box">
                                            <div class="box-content">
                                                <p class="variable-name">WHS</p>
                                                <el-progress class="variable-value" :percentage="(Number(whs_accomplishment) * 100) > 100 ? 100 : (Number(whs_accomplishment) * 100)" :show-text="false" :color="customColorMethodCollection"></el-progress>
                                                <p class="variable-name">Cumplimiento <span>({{ numberFormat(Math.round(Number(whs_accomplishment) * 10000) / 100) }}%)</span></p>
                                                <p class="variable-name">Peso <span>40%</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                <div class="card-var">
                                    <div class="wrapper-channels-rv">
                                        <div class="box">
                                            <div class="box-content">
                                                <p class="variable-name">RETAIL</p>
                                                <el-progress class="variable-value" :percentage="(Number(retail_accomplishment) * 100) > 100 ? 100 : (Number(retail_accomplishment) * 100)" :show-text="false" :color="customColorMethodCollection"></el-progress>
                                                <p class="variable-name">Cumplimiento <span>({{ numberFormat(Math.round(Number(retail_accomplishment) * 10000) / 100) }}%)</span></p>
                                                <p class="variable-name">Peso <span>60%</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="card-channel-accomplishments position-relative">
                                    <div class="wrapper-channels">
                                        <div class="box box-merged">
                                            <div class="box-content" style="color: #605B63 !important">
                                                <p class="variable-name p-2">Cumplimiento Ponderado</p>
                                            </div>
                                        </div>
                                        <div class="box">
                                            <div class="box-content" style="color: #605B63 !important">
                                                <p class="valor p-2">{{ numberFormat(Math.round(Number(rv_accomplishment) * 10000) / 100) }}%</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Fin Velocimetro -->
        </div>

        <div v-else class="row">
            <div v-if="data_current_rv && data_current_rv.metrics && data_current_rv.metrics.length > 0" class="row mt-5">
                <div class="content-rv col-md-12 col-lg-12 col-xl-6">
                    <div class="calculator mb-3">
                        <div class="row">
                            <div v-for="item in data_current_rv.metrics" class="col-12 col-sm-12 col-md-12 col-lg-6">
                                <div class="card-var position-relative" :class="item.accelerator==1 ? 'accelerator' : item.accelerator==2 ? 'super-accelerator' :'no-accelerator'">
                                    <div class="wrapper-var">
                                        <div class="box box1">
                                            <div class="box-content">
                                                <p class="variable-name">{{ item.kpi }}</p>
                                                <input  class="input-number" type="number" v-model="item.real" @keyup="updateVariableData(item)" v-number-only />
                                                <el-progress class="variable-value" :percentage="(Number(item.advance) * 100) > 100 ? 100 : (Number(item.advance) * 100)" :show-text="false" :color="customColorMethodRV(item.advance, item.accelerator)"></el-progress>
                                                <p class="text-advance">({{ numberFormat(Math.round(item.advance * 10000) / 100) }}%)</p>
                                            </div>
                                        </div>
                                        <div class="box box2">
                                            <div class="box-content">
                                                <p class="rotulo">Objetivo</p>
                                                <p v-if="getTypeVariable(item.kpi)" class="valor">$ {{ numberFormat(item.goal) }}</p>
                                                <p v-else class="valor">{{ numberFormat(item.goal) }}</p>
                                            </div>
                                        </div>
                                        <div class="box box3">
                                            <div class="box-content">
                                                <p class="rotulo">Pendiente</p>
                                                <p v-if="(item.accelerator == 2) && (getTypeVariable(item.kpi) == true)" class="valor">
                                                    $ {{ ((item.goal * (accelerators[1].value / 100)) - (item.real) <= 0) ? 0 : numberFormat(Number((item.goal * (accelerators[1].value / 100)) - item.real).toFixed(0)) }}
                                                </p>
                                                <p v-else-if="(item.accelerator == 2) && (getTypeVariable(item.kpi) == false)" class="valor">
                                                    {{ ((item.goal * (accelerators[1].value / 100)) - (item.real) <= 0) ? 0 : numberFormat(Number((item.goal * (accelerators[1].value / 100)) - item.real).toFixed(0)) }}
                                                </p>
                                                <p v-else-if="(item.accelerator == 1) && (getTypeVariable(item.kpi) == true)" class="valor">
                                                    $ {{ ((item.goal * (accelerators[0].value / 100)) - (item.real) <= 0) ? 0 : numberFormat(Number((item.goal * (accelerators[0].value / 100)) - item.real).toFixed(0)) }}
                                                </p>
                                                <p v-else-if="(item.accelerator == 1) && (getTypeVariable(item.kpi) == false)" class="valor">
                                                    {{ ((item.goal * (accelerators[0].value / 100)) - (item.real) <= 0) ? 0 : numberFormat(Number((item.goal * (accelerators[0].value / 100)) - item.real).toFixed(0)) }}
                                                </p>
                                                <p v-else-if="(item.accelerator == 0) && (getTypeVariable(item.kpi) == true)" class="valor">
                                                    $ {{ (item.goal - item.real <= 0) ? 0 : numberFormat(Number((item.goal - item.real).toFixed(0))) }}
                                                </p>
                                                <p v-else-if="(item.accelerator == 0) && (getTypeVariable(item.kpi) == false)" class="valor">
                                                    {{ (item.goal - item.real <= 0) ? 0 : numberFormat(Number(item.goal - item.real).toFixed(0)) }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="box box4 position-relative">
                                            <div v-if="item.accelerator==1" class="position-absolute top-0 start-50 translate-middle">
                                                <img v-if="item.advance<0.9" src="/img-version2/icons/cohete-rojo.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                                <img v-else-if="item.advance>=0.9 && item.advance<1" src="/img-version2/icons/cohete-naranja.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                                <img v-else-if="item.advance>=1 && item.advance<1.1" src="/img-version2/icons/cohete-verde.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                                <img v-else-if="item.advance>=1.1" src="/img-version2/icons/cohete-azul.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                            </div>
                                            <div v-else-if="item.accelerator==2" class="position-absolute top-0 start-50 translate-middle">
                                                <img v-if="item.advance<0.9" src="/img-version2/icons/meteorito-rojo.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                                <img v-else-if="item.advance>=0.9 && item.advance<1" src="/img-version2/icons/meteorito-naranja.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                                <img v-else-if="item.advance>=1 && item.advance<1.2" src="/img-version2/icons/meteorito-verde.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                                <img v-else-if="item.advance>=1.2" src="/img-version2/icons/meteorito-morado.svg" alt="" @click="showModalRentVariable" style="width: 26px;">
                                            </div>
                                            <div class="box-content">
                                                <p class="rotulo">Peso</p>
                                                <p class="valor">{{ Math.round(item.peso * 100) }}%</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Card de cumplimiento -->
                        <div v-if="segment_display_rv && segment_display_rv.segment == 15" class="row">
                            <div class="col-12">
                                <div class="card-var position-relative">
                                    <div class="wrapper-channels">
                                        <div class="box box1">
                                            <div class="box-content">
                                                <p class="variable-name p-2">Cumplimiento</p>
                                            </div>
                                        </div>
                                        <div class="box">
                                            <div class="box-content">
                                                <p class="valor p-2">{{ numberFormat(Math.round(Number(accomplishment) * 10000) / 100) }}%</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class=" col-12">
                                <button @click="restoreData()" class="btn btn-lg btn-block btn-apply mb-3 w-100">Restaurar <i class="fa-solid fa-arrow-rotate-left"></i></button>
                            </div>
                        </div>
                        <!-- Card de cumplimiento -->

                        <br>

                        <div v-if="data_current_rv && data_current_rv.metrics_totals && Object.keys(data_current_rv.metrics_totals).length > 0 && segment_display_rv.segment != 15" class="row">
                        <!-- <div v-if="data_current_rv && data_current_rv.metrics_totals && data_current_rv.metrics_totals.length !== 0" class="row"> -->
                            <h5 class="text-indigo-darkness text-title-bat">Resumen R.V.</h5>
                            <div class=" col-12 col-sm-12 col-md-12 col-lg-6">
                                <div class="card-var">
                                    <div class="wrapper-var-cumpli">
                                        <div class="box box2 border-end">
                                            <div class="box-content py-2">
                                                <p class="rotulo text-start">Cumplimiento</p>
                                            </div>
                                        </div>
                                        <div class="box box3">
                                            <div class="box-content">
                                                <!-- <p class="rotulo">{{ Math.round(Number(data_current_rv.metrics_totals.accomplishment) * 10000) / 100 }}%</p> -->
                                                <p class="rotulo">{{ numberFormat(Math.round(Number(accomplishment) * 10000) / 100) }}%</p>
                                            </div>
                                        </div>
                                        <div class="box box2 border-top border-end">
                                            <div class="box-content py-2 d-flex justify-content-between align-items-center">
                                                <p v-if="segment_display_rv && [13, 16].includes(segment_display_rv.segment)" class="rotulo text-start">Digital</p>
                                                <p v-else class="rotulo text-start">Cartera</p>
                                                <img v-if="Number(data_current_rv.metrics_totals.advance_collection) < Number(data_current_rv.metrics_totals.target_threshold)" src="/img-version2/icons/candado-cerrado.svg" alt="">
                                                <img v-else src="/img-version2/icons/candado-abierto.svg" alt="">
                                            </div>
                                        </div>
                                        <div class="box box3 border-top">
                                            <div class="box-content collection">
                                                <input  class="input-number" type="number"
                                                    :value="Math.round(Number(data_current_rv.metrics_totals.real_collection))"
                                                    @input="event => {
                                                        data_current_rv.metrics_totals.real_collection = Number(event.target.value);
                                                        updateCollectionData();
                                                    }"
                                                    v-number-only
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                <div class="card-var">
                                    <div v-if="data_current_rv && data_current_rv.metrics_totals" class="wrapper-collection">
                                        <div class="box box1">
                                            <div class="box-content">
                                                <p v-if="segment_display_rv && [13, 16].includes(segment_display_rv.segment)" class="variable-name">Digital</p>
                                                <p v-else class="variable-name">Cartera Corriente</p>
                                                <p class="text-advance">
                                                    {{ segment_display_rv && [13, 16].includes(segment_display_rv.segment) ? '' : '$ ' }}
                                                    {{ numberFormat(data_current_rv.metrics_totals.real_collection) }}
                                                </p>
                                                <el-progress class="variable-value" :percentage="(Number(data_current_rv.metrics_totals.advance_collection) * 100) > 100 ? 100 : (Number(data_current_rv.metrics_totals.advance_collection) * 100)" :show-text="false" :color="customColorMethodCollection"></el-progress>
                                                <p class="text-advance">({{ numberFormat(Number(data_current_rv.metrics_totals.advance_collection) >= 1 ? 100 : Math.round(Number(data_current_rv.metrics_totals.advance_collection) * 10000) / 100) }}%)</p>
                                            </div>
                                        </div>
                                        <div class="box box2">
                                            <div class="box-content">
                                                <p class="rotulo">Objetivo</p>
                                                <p class="valor">{{ numberFormat(Math.round(Number(data_current_rv.metrics_totals.target_threshold) * 10000) / 100) }}%</p>
                                            </div>
                                        </div>
                                        <div class="box box3">
                                            <div class="box-content">
                                                <p v-if="segment_display_rv && [13, 16].includes(segment_display_rv.segment)" class="rotulo">Pendiente</p>
                                                <p v-else class="rotulo">Saldo Cartera</p>
                                                <p class="valor">
                                                    {{ segment_display_rv && [13, 16].includes(segment_display_rv.segment) ? '' : '$ ' }}
                                                    {{ numberFormat(data_current_rv.metrics_totals.pending_collection) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div v-if="data_current_rv && data_current_rv.metrics_awards && Object.keys(data_current_rv.metrics_awards).length !== 0 !== 0 && ![13, 14, 15, 16, 17].includes(segment_display_rv.segment)" class="col-12 col-sm-12 col-md-12 col-lg-6">
                                <div v-for="(item, index) in data_current_rv.metrics_awards" :key="index" class="card-var">
                                    <div class="wrapper-collection">
                                        <div class="box box1">
                                            <div class="box-content">
                                                <p class="variable-name">{{(item.detail == '' || item.detail == null) ? 'Comodín Digital' : item.detail }}</p>
                                                <input  class="input-number" type="number"
                                                    :value="Math.round(Number(item.real))"
                                                    @input="event => item.real = Number(event.target.value)"
                                                    @keyup="updateRealAwardData(item, index)"
                                                    v-number-only
                                                />
                                                <el-progress class="variable-value" :percentage="(Number(item.advance) * 100) > 100 ? 100 : (Number(item.advance) * 100)" :show-text="false" :color="customColorMethod"></el-progress>
                                                <p class="text-advance">({{ numberFormat(Math.round(Number(item.advance) * 10000) / 100) }}%)</p>
                                            </div>
                                        </div>
                                        <div class="box box2">
                                            <div class="box-content">
                                                <p class="rotulo">Objetivo</p>
                                                <p class="valor">{{ numberFormat(item.goal) }}</p>
                                            </div>
                                        </div>
                                        <div class="box box3">
                                            <div class="box-content">
                                                <p class="rotulo">Pendiente</p>
                                                <p class="valor">{{ numberFormat((item.goal - item.real) <= 0 ? 0 : item.goal - item.real) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="data_current_rv && data_current_rv.metrics_awards && data_current_rv.metrics_awards.length !== 0 && ![13, 14, 15, 16, 17].includes(segment_display_rv.segment)" class="col-12 col-sm-12 col-md-12 col-lg-6">
                                <div class="card-var">
                                    <div class="wrapper-var-cumpli">
                                        <div class="box box2 border-end">
                                            <div class="box-content py-2 d-flex justify-content-between align-items-center">
                                                <p class="rotulo text-start">Comodín</p>
                                                <img v-if="Number(total_award) == 0" src="/img-version2/icons/estrella-roja.svg" alt="" @click="showModalWildcard">
                                                <img v-else-if="Number(total_award) > 0 && Number(total_award) < Number(total_expected)" src="/img-version2/icons/estrella-naranja.svg" alt="" @click="showModalWildcard">
                                                <img v-else-if="Number(total_award) == Number(total_expected)" src="/img-version2/icons/estrella-verde.svg" alt="" @click="showModalWildcard">
                                            </div>
                                        </div>
                                        <div class="box box3">
                                            <div class="box-content">
                                                <p class="rotulo">{{ numberFormat(Math.round(Number(total_award) * 10000) / 100) }}%</p>
                                            </div>
                                        </div>
                                        <div class="box box2 border-top border-end">
                                            <div class="box-content py-2 d-flex justify-content-between align-items-center">
                                                <p class="rotulo text-start">Cumplimiento + Comodín</p>

                                            </div>
                                        </div>
                                        <div class="box box3 border-top">
                                            <div class="box-content ">
                                                <p v-if="final_accomplishment != 0" class="rotulo">{{ numberFormat(Math.round(final_accomplishment * 100) / 100) }}%</p>
                                                <p v-else class="rotulo">{{ 0 }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="data_current_rv && data_current_rv.metrics_awards && Object.keys(data_current_rv.metrics_awards).length !== 0 && ![13, 14, 15, 16, 17].includes(segment_display_rv.segment)" class="mb-4">
                            <a class="link-explanatory-popup text-bat" @click="showModalWildcard">
                                <img src="/img-version2/icons/info-circle-blue.svg" alt="Icono">
                                <span class="reference">Encuentra aquí más sobre tu comodín</span>
                            </a>
                        </div>

                        <div v-if="showModalPopupsWildcard">
                            <popups-wildcard :closeModalWildcard="closeModalWildcard"></popups-wildcard>
                        </div>

                        <div v-if="data_current_rv && Object.keys(data_current_rv).length !== 0 && segment_display_rv && segment_display_rv.penalty && segment_display_rv.segment != 15" class="row">
                            <div class="col-12">
                                <div class="d-flex align-items-center" :class="state_message">
                                    <div class="content d-flex align-items-center p-2 flex-column">
                                        <p v-if="state_collection == 'red-semaforo'" class="mb-0"> Anímate a superar tus retos. <br>Evita la penalización del <strong>{{ segment_display_rv.penalty }}%</strong> en tu <strong>renta variable</strong>.</p>
                                        <p v-else-if="state_collection == 'green-semaforo' && [13, 16].includes(segment_display_rv.segment)" class="mb-0"> Alcanzaste el <strong>{{ numberFormat(Math.round(Number(data_current_rv.metrics_totals.target_threshold) * 10000) / 100) }}%</strong> de tu objetivo digital. <br>No tienes penalizado tu <strong>Pago R.V</strong>.</p>
                                        <p v-else-if="state_collection == 'green-semaforo' && ![13, 16].includes(segment_display_rv.segment)" class="mb-0"> Alcanzaste el <strong>{{ numberFormat(Math.round(Number(data_current_rv.metrics_totals.target_threshold) * 10000) / 100) }}%</strong> de tu objetivo de cartera. <br>No tienes penalizado tu <strong>Pago R.V</strong>.</p>
                                    </div>
                                </div>
                            </div>

                            <div class=" col-12">
                                <button @click="restoreData()" class="btn btn-lg btn-block btn-apply my-3 w-100">Restaurar <i class="fa-solid fa-arrow-rotate-left"></i></button>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="col-md-12 col-lg-12 col-xl-6">
                    <div v-if="data_current_rv && data_current_rv.metrics_totals && data_current_rv.metrics_totals !== 0" class="row velocimetro">
                        <h6 v-if="segment_display_rv.segment != 15" class="d-flex mt-4 justify-content-center align-items-center">
                            {{  [13, 16].includes(segment_display_rv.segment) ? 'Candado Digital' : 'Candado de Cartera' }}
                            <img class="ms-3" v-if="Number(data_current_rv.metrics_totals.advance_collection) < Number(data_current_rv.metrics_totals.target_threshold)" src="/img-version2/icons/candado-cerrado.svg" alt="">
                            <img class="ms-3" v-else src="/img-version2/icons/candado-abierto.svg" alt="">
                        </h6>
                        <div class="container w-100 tacometro">
                            <div class="row justify-content-center">
                                <div class="col-md-10 col-lg-10">
                                    <div class="d-flex justify-content-center flex-wrap content-margin">
                                        <div class="hidden-circle">
                                            <div class="skill">
                                                <div class="point" id="point" ref="point"></div>
                                                <div class="outer">
                                                    <div class="inner">
                                                        <div class="number" id="number" ref="result_number">
                                                            <p v-if="rv_result">{{ rv_result }}</p>
                                                            <p v-else>{{ 0 }}</p>
                                                        </div>
                                                        <div class="text">
                                                            <p>Pago R.V </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <svg id="circle" xmlns="http://www.w3.org/2000/svg" version="1.1" width="374px" height="374px" ref="circle_simulator">
                                                    <defs>
                                                        <linearGradient id="GradientColorSimulator">
                                                            <stop offset="0%" stop-color="" ref="stop1"></stop>
                                                            <stop offset="100%" stop-color="" ref="stop2"></stop>
                                                        </linearGradient>
                                                    </defs>
                                                    <circle id="circleIndicatorSimulator" cx="188" cy="188" r="170" stroke-linecap="round"></circle>
                                                </svg>

                                            </div>
                                        </div>
                                        <div class="col-12 text-variable d-flex justify-content-between">
                                            <p>0</p>
                                            <p class="disabled star" id="star" ref="star"> <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.2076 23.6022C14.3106 23.5397 14.4398 23.5397 14.5428 23.6022L20.0389 26.9352C21.7515 27.9738 23.8697 26.4395 23.4167 24.4884L21.9538 18.1876C21.9268 18.0711 21.9663 17.9492 22.0565 17.8706L26.9339 13.6252C28.4416 12.3128 27.6319 9.83314 25.6403 9.66336L19.2329 9.11715C19.1133 9.10696 19.0091 9.0313 18.9625 8.92068L16.4603 2.98879C15.6822 1.14412 13.0682 1.14412 12.2901 2.98879L9.78792 8.92068C9.74126 9.0313 9.63714 9.10696 9.51751 9.11715L3.11013 9.66336C1.11849 9.83314 0.30884 12.3128 1.81653 13.6252L6.69389 17.8706C6.78411 17.9492 6.8236 18.0711 6.79655 18.1876L5.33366 24.4884C4.88067 26.4395 6.99892 27.9738 8.71155 26.9352L14.2076 23.6022Z" fill="#EFEFEF" stroke="white" stroke-width="1.93975" />
                                                </svg>
                                                <span v-if="payments_rv && payments_rv.length > 0">{{ payments_rv[payments_rv.length - 1].rv_payment }}</span>
                                                <span v-else>150</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="content-bloq">
                            <div class="see-table d-flex justify-center mb-4">
                                <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#tableModalSimulator">
                                    Ver tabla de conversión
                                </button>
                            </div>

                            <div v-if="segment_display_rv.segment != 15">
                                <p v-if="[13, 16].includes(segment_display_rv.segment)" class="text-break text-start text-bat">Recuerda que debes tener desbloqueado el candado digital para cumplir exitosamente tu renta.</p>
                                <p v-else class="text-break text-start text-bat">Recuerda que debes tener desbloqueado el candado de cartera para cumplir exitosamente tu renta.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { cloneDeep } from 'lodash';

export default {
    name: 'MetricsRVSimulator',
    props: {
        data_rv_sim: {
            default: null,
        },
        isGrouped: {
            default: false,
        },
        activeTab: {
            default: null,
        },
        segment_display_rv: {
            default: null,
        },
        accelerators: {
            default: null,
        },
        payments_rv: {
            default: null,
        },
    },
    data() {
        return {
            data_current_rv: cloneDeep(this.data_rv_sim),
            active_tab: null,

            state_collection: '',
            state_message: '',

            showModalPopupsWildcard: false,

            total_award: 0,
            total_expected: 0,

            current_items: [],

            accomplishment: 0,
            current_accomplishment: 0,
            whs_accomplishment: 0,
            retail_accomplishment: 0,
            rv_accomplishment: 0,
            final_accomplishment: 0,

            rv_result: 0,
        }
    },
    mounted() {
        if(this.data_current_rv != null) {
            this.setCurrentItems();
        }
    },
    watch: {
        activeTab: {
            handler(newVal) {
                this.active_tab = newVal;
            },
            immediate: true,
        },
        data_current_rv: {
            handler() {
                if(this.isGrouped) {
                    this.setCurrentItems();
                    this.calculateChannelsAccomplishment();
                } else {
                    this.calculateAccomplishment();
                }
            },
            immediate: true,
            deep: true,
        },
        active_tab: {
            handler() {
                this.setCurrentItems();
            },
        },
        // current_items: {
        //     handler() {
        //         this.calculateCurrentAccomplishment();
        //     },
        // },
        rv_accomplishment: {
            handler() {
                this.calculateResult();
            },
        },
        // rv_result: {
        //     handler() {
        //         this.updateProgressFinalRV();
        //     },
        // },
    },
    methods: {
        restoreData() {
            this.data_current_rv = cloneDeep(this.data_rv_sim)
            this.calculateAccomplishment()
        },
        setCurrentItems() {
            if (this.data_current_rv && this.data_current_rv.metrics && Object.keys(this.data_current_rv.metrics).length > 1 && this.isGrouped) {
                this.current_items = this.data_current_rv.metrics[this.active_tab] || [];
            }
        },
        setPrincipalOption(option) {
            this.principalOption = option
            if(this.principalOption == 'renta_variable') {
                if(this.countModalRentVariable == 0) {
                    this.showModalRentVariable();
                    this.countModalRentVariable = 1;
                }
            }
        },
        getTypeVariable(cadena) {
            if(cadena.includes('$')) {
                return true;
            } else {
                return false;
            }
        },
        customColorMethod(percentage) {
            if (percentage >= 100) {
                return 'green';
            } else if (percentage >= 90 && percentage < 100) {
                return 'orange';
            } else {
                return 'red';
            }
        },
        customColorMethodRV(advance, accelerator) {
            if (advance < 0.9) {
                return 'red';
            } else if (advance >= 0.9 && advance < 1) {
                return 'orange';
            }

            if (accelerator == 0) {
                if (advance >= 1) {
                    return 'green';
                }
            } else if (accelerator == 1) {
                if (advance >= 1 && advance < (this.accelerators[0].value / 100)) {
                    return 'green';
                } else if (advance >= (this.accelerators[0].value / 100)) {
                    return '#00B5F3';
                }
            } else if (accelerator == 2) {
                if (advance >= 1 && advance < (this.accelerators[1].value / 100)) {
                    return 'green';
                } else if (advance >= (this.accelerators[1].value / 100)) {
                    return '#5A1E85';
                }
            }
        },
        customColorMethodCollection(percentage) {
            if (percentage >= 100) {
                return 'green';
            } else if (this.data_current_rv && percentage >= (Math.round(Number(this.data_current_rv.metrics_totals.target_threshold) * 10000) / 100) && percentage < 100) {
                return 'orange';
            } else {
                return 'red';
            }
        },
        numberFormat(number) {
            const exp = /(\d)(?=(\d{3})+(?!\d))/g
            const rep = '$1.'
            let arr = number.toString().split('.')
            arr[0] = arr[0].replace(exp,rep)
            return arr[1] ? arr.join(','): arr[0]
        },
        showModalWildcard() {
            this.showModalPopupsWildcard = true
        },
        showModalRentVariable() {
            this.showModalVariable = true
        },
        closeModalWildcard() {
            this.showModalPopupsWildcard = false
        },
        calculateTotalAward() {
            let totalAward = 0;
            let totalAwardExpected = 0;
            if(this.data_current_rv && this.data_current_rv.metrics_awards) {
                for (let i = 0; i < this.data_current_rv.metrics_awards.length; i++) {
                    if(this.data_current_rv.metrics_awards[i].value && Number(this.data_current_rv.metrics_awards[i].advance) >= 1 ) {
                        totalAward += Number(this.data_current_rv.metrics_awards[i].value);
                    }
                    totalAwardExpected += Number(this.data_current_rv.metrics_awards[i].value);
                }
            }
            this.total_award = totalAward;
            this.total_expected = totalAwardExpected;
        },
        approximatelyEqual(a, b) {
            let tolerance = 1e-4
            if(Math.abs(a - b) < tolerance) {
                return a;
            }
            return b;
        },
        calculateCurrentAccomplishment() {
            if(this.current_items && this.current_items.length > 0) {
                let acc_rv = 0
                this.current_items.forEach(function(element) {
                    acc_rv += Number(element.peso) * Number(element.advance)
                }, acc_rv);

                this.current_accomplishment = this.approximatelyEqual(Math.round(acc_rv), acc_rv);
            }
        },
        calculateAccomplishment() {
            if(this.data_current_rv && this.data_current_rv.metrics && this.data_current_rv.metrics.length > 0) {
                let acc_rv = 0
                let advance_accelerator_1 = this.accelerators[0].value / 100
                let advance_accelerator_2 = this.accelerators[1].value / 100

                this.data_current_rv.metrics.forEach(function(element) {
                    let advance = 0

                    if(element.accelerator == 0) {
                        if(Number(element.advance) >= 1) {
                            advance = 1
                        } else {
                            advance = Number(element.advance)
                        }
                    } else if(element.accelerator == 1) {
                        if(Number(element.advance) >= advance_accelerator_1 ) {
                            advance = advance_accelerator_1
                        } else {
                            advance = Number(element.advance)
                        }
                    } else if(element.accelerator == 2) {
                        if(Number(element.advance) >= advance_accelerator_2) {
                            advance = advance_accelerator_2
                        } else {
                            advance = Number(element.advance)
                        }
                    }

                    acc_rv += Number(element.peso) * advance
                }, acc_rv);

                this.accomplishment = this.approximatelyEqual(Math.round(acc_rv), acc_rv)

                this.calculateFinalAccomplishment()
            }
        },
        calculateChannelsAccomplishment() {
            if(this.data_current_rv.metrics && Object.keys(this.data_current_rv.metrics).length > 1 && this.isGrouped) {
                let acc_rv_whs = 0
                let acc_rv_retail = 0

                let advance_accelerator_1 = this.accelerators[0].value / 100
                let advance_accelerator_2 = this.accelerators[1].value / 100

                this.data_current_rv.metrics['WHS'].forEach(function(element) {
                    let advance = 0

                    if(element.accelerator == 0) {
                        if(Number(element.advance) >= 1) {
                            advance = 1
                        } else {
                            advance = Number(element.advance)
                        }
                    } else if(element.accelerator == 1) {
                        if(Number(element.advance) >= advance_accelerator_1 ) {
                            advance = advance_accelerator_1
                        } else {
                            advance = Number(element.advance)
                        }
                    } else if(element.accelerator == 2) {
                        if(Number(element.advance) >= advance_accelerator_2) {
                            advance = advance_accelerator_2
                        } else {
                            advance = Number(element.advance)
                        }
                    }

                    acc_rv_whs += Number(element.peso) * advance

                    // acc_rv_whs += Number(element.peso) * Number(element.advance)
                }, acc_rv_whs);

                this.data_current_rv.metrics['RETAIL'].forEach(function(element) {
                    let advance = 0

                    if(element.accelerator == 0) {
                        if(Number(element.advance) >= 1) {
                            advance = 1
                        } else {
                            advance = Number(element.advance)
                        }
                    } else if(element.accelerator == 1) {
                        if(Number(element.advance) >= advance_accelerator_1 ) {
                            advance = advance_accelerator_1
                        } else {
                            advance = Number(element.advance)
                        }
                    } else if(element.accelerator == 2) {
                        if(Number(element.advance) >= advance_accelerator_2) {
                            advance = advance_accelerator_2
                        } else {
                            advance = Number(element.advance)
                        }
                    }

                    acc_rv_retail += Number(element.peso) * advance

                    // acc_rv_retail += Number(element.peso) * Number(element.advance)
                }, acc_rv_retail);

                this.whs_accomplishment = this.approximatelyEqual(Math.round(acc_rv_whs), acc_rv_whs);
                this.retail_accomplishment = this.approximatelyEqual(Math.round(acc_rv_retail), acc_rv_retail);

                this.rv_accomplishment = (this.whs_accomplishment * 0.4) + (this.retail_accomplishment * 0.6);
            }

            this.calculateResult()
        },
        calculateFinalAccomplishment() {
            this.calculateTotalAward()

            if (this.segment_display_rv && ![13, 14, 15, 16, 17].includes(this.segment_display_rv.segment)) {
                this.final_accomplishment = (Number(this.accomplishment) * 100) + (Number(this.total_award) * 100)
            } else {
                this.final_accomplishment = Number(this.accomplishment) * 100
            }

            if(this.data_current_rv && this.data_current_rv.metrics_totals && this.data_current_rv.metrics_totals.advance_collection < Number(this.data_current_rv.metrics_totals.target_threshold)) {
                this.state_collection = 'red-semaforo'
                this.state_message = 'msj-semaforo-red'
            } else {
                this.state_collection = 'green-semaforo'
                this.state_message = 'msj-semaforo-green'
            }

            this.calculateResult()
        },
        calculateResult() {
            let acc_rv = 0

            if (this.isGrouped) {
                acc_rv = Number(this.rv_accomplishment) * 100
            } else {
                acc_rv = this.final_accomplishment
            }

            if (this.payments_rv && this.payments_rv.length > 0) {
                // Ordenamos los objetos por "accomplishment" de menor a mayor
                let sortedPayments = [...this.payments_rv].sort((a, b) => a.accomplishment - b.accomplishment);

                for (let i = 0; i < sortedPayments.length; i++) {
                    let current = sortedPayments[i];
                    let next = sortedPayments[i + 1]; // Siguiente elemento

                    if (i === 0 && acc_rv < current.accomplishment) {
                        this.rv_result = 0;
                        break;
                    } else if (next && acc_rv >= current.accomplishment && acc_rv < next.accomplishment) {
                        this.rv_result = current.rv_payment;
                        break;
                    } else if (i === sortedPayments.length - 1 && acc_rv >= current.accomplishment) {
                        this.rv_result = current.rv_payment;
                    }
                }
            }

            if(this.rv_result > 0 && this.segment_display_rv && this.segment_display_rv.penalty && this.segment_display_rv.segment != 15 && !this.isGrouped) {
                if(this.data_current_rv && this.data_current_rv.metrics_totals && Number(this.data_current_rv.metrics_totals.advance_collection) < Number(this.data_current_rv.metrics_totals.target_threshold)) {
                    this.rv_result = Math.round(this.rv_result * (1 - (this.segment_display_rv.penalty / 100)))
                }
            }

            this.updateProgressFinalRV()
        },
        updateVariableData(item) {
            let accomplishment = Number(item.real) / Number(item.goal)
            if(item.accelerator === 2) {
                if(accomplishment > (this.accelerators[1].value / 100)) {
                    item.advance = (this.accelerators[1].value / 100)
                } else {
                    item.advance = accomplishment
                }
            } else if (item.accelerator === 1) {
                if(accomplishment > (this.accelerators[0].value / 100)) {
                    item.advance = (this.accelerators[0].value / 100)
                } else {
                    item.advance = accomplishment
                }
            } else if (item.accelerator === 0) {
                if(accomplishment > 1) {
                    item.advance = 1
                } else {
                    item.advance = accomplishment
                }
            } else {
                //
            }

            if (this.isGrouped) {
                this.calculateChannelsAccomplishment();
            } else {
                this.calculateAccomplishment()
            }

            this.calculateFinalAccomplishment()
        },
        updateCollectionData() {
            if(this.data_current_rv && this.data_current_rv.metrics_totals) {
                if (Number(this.data_current_rv.metrics_totals.real_collection) >= Number(this.data_current_rv.metrics_totals.goal_collection)) {
                    this.data_current_rv.metrics_totals.advance_collection = 1
                    this.data_current_rv.metrics_totals.pending_collection = 0
                } else {
                    this.data_current_rv.metrics_totals.advance_collection = Number(this.data_current_rv.metrics_totals.real_collection) / Number(this.data_current_rv.metrics_totals.goal_collection)
                    this.data_current_rv.metrics_totals.pending_collection = Number(this.data_current_rv.metrics_totals.goal_collection) - Number(this.data_current_rv.metrics_totals.real_collection)
                }
            }

            this.calculateFinalAccomplishment()
        },
        updateRealAwardData(item, index) {
            if (this.data_current_rv.metrics_awards[index].real >= this.data_current_rv.metrics_awards[index].goal) {
                this.data_current_rv.metrics_awards[index].advance = 1
            } else {
                this.data_current_rv.metrics_awards[index].advance = this.data_current_rv.metrics_awards[index].real / this.data_current_rv.metrics_awards[index].goal
            }

            this.calculateFinalAccomplishment()
        },
        updateProgressFinalRV() {
            setTimeout(() => {
                let result_number = this.$refs.result_number
                let point = this.$refs.point
                let star = this.$refs.star
                let val = 0
                let stop1 = this.$refs.stop1
                let stop2 = this.$refs.stop2

                if(this.rv_result != 0) {
                    val = this.rv_result

                    if(result_number && val) {
                        let svgId = this.$refs.circle_simulator
                        let numero2

                        if(this.payments_rv && this.payments_rv.length > 0) {
                            numero2 = (parseInt(val) *  170) / this.payments_rv[this.payments_rv.length - 1].rv_payment
                        } else {
                            numero2 = (parseInt(val) *  170) / 150
                        }

                        svgId.style.transform = `translate(-50% , -50%) rotate(${numero2}deg)`
                        point.style.transform = `translate(-50% , -50%) rotate(${numero2}deg)`
                        if (parseInt(val) <= 0){
                            stop1.setAttribute("stop-color", "#A8A8A8");
                            stop2.setAttribute("stop-color", "#605B63");
                            result_number.style.backgroundImage = '-webkit-linear-gradient(180deg, #A8A8A8 0%, #605B63 97.64%)';

                            point.classList.remove("red")
                            point.classList.remove("orange")
                            point.classList.remove("green")
                            point.classList.add("d-none")

                            star.classList.remove("active")
                            star.classList.add("disabled")
                        } else if (parseInt(val) > 0 && parseInt(val) < 50){
                            stop1.setAttribute("stop-color", "#ff9999");
                            stop2.setAttribute("stop-color", "#ff0000");
                            result_number.style.backgroundImage = '-webkit-linear-gradient(180deg, #ff9999 0%, #ff0000 97.64%)';

                            point.classList.add("red")
                            point.classList.remove("orange")
                            point.classList.remove("green")
                            point.classList.remove("d-none")

                            star.classList.remove("active")
                            star.classList.add("disabled")
                        } else if (parseInt(val) >= 50 && parseInt(val) < 100){
                            stop1.setAttribute("stop-color", "#FFD600");
                            stop2.setAttribute("stop-color", "#F87C00");
                            result_number.style.backgroundImage = '-webkit-linear-gradient(180deg, #FFD600 0%, #F87C00 97.64%)';

                            point.classList.remove("red")
                            point.classList.add("orange")
                            point.classList.remove("green")
                            point.classList.remove("d-none")

                            star.classList.remove("active")
                            star.classList.add("disabled")
                        } else if (parseInt(val) >= 100){
                            stop1.setAttribute("stop-color", "#6AC11F");
                            stop2.setAttribute("stop-color", "#00660A");
                            result_number.style.backgroundImage = '-webkit-linear-gradient(180deg, #6AC11F 0%, #00660A 97.64%)';

                            point.classList.remove("red")
                            point.classList.remove("orange")
                            point.classList.add("green")
                            point.classList.remove("d-none")

                            star.classList.add("active")
                            star.classList.remove("disabled")
                        }
                    }
                } else {
                    let svgId = this.$refs.circle_simulator
                    let result_number2 = 0
                    svgId.style.transform = `translate(-50% , -50%) rotate(${result_number2}deg)`
                    point.style.transform = `translate(-50% , -50%) rotate(${result_number2}deg)`

                    stop1.setAttribute("stop-color", "#A8A8A8");
                    stop2.setAttribute("stop-color", "#605B63");
                    result_number.style.backgroundImage = '-webkit-linear-gradient(180deg, #A8A8A8 0%, #605B63 97.64%)';

                    point.classList.remove("red")
                    point.classList.remove("orange")
                    point.classList.remove("green")
                    // point.classList.add("d-none")
                    // point.classList.add("")

                    star.classList.remove("active")
                    star.classList.add("disabled")
                }
            }, 200);
        }
    },
}
</script>

<style scoped>

.card-channel-accomplishments {
    box-shadow: 0px 0px 5px rgb(215, 215, 215);
    border-radius: 8px;
    background-color: white;
    margin-bottom: 20px;
}

.card-channel-accomplishments .wrapper-channels {
    display: grid;
    grid-gap: 1px;
    grid-template-columns: 33.33% 33.33% 33.33%;
    height: 100%;
}

.card-channel-accomplishments .wrapper-channels .box1 {
    border-right: 1px dotted #b3b3b3;
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;
}

.card-channel-accomplishments .wrapper-channels .box2 {
    border-right: 1px dotted #b3b3b3;
}

.card-channel-accomplishments .wrapper-channels .box {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    font-size: 12px;
}

.card-channel-accomplishments .wrapper-channels .box .box-content {
    color: #312D2D !important;
    font-size: 14px;
    width: 100%;
    padding: 0 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.card-channel-accomplishments .wrapper-channels .box .box-content .variable-name {
    color: #312D2D !important;
    font-size: 14px;
    text-align: center;
    font-weight: bold;
    margin: 0px;
}

.card-channel-accomplishments .wrapper-channels .box .box-content .rotulo {
    color: #312D2D !important;
    font-size: 14px;
    text-align: center;
    font-weight: bold;
    margin: 0px;
}

.card-channel-accomplishments .wrapper-channels .box .box-content .valor {
    color: #312D2D !important;
    font-size: 14px;
    text-align: center;
    margin: 3px 0px;
    line-height: 12px;
}

.card-channel-accomplishments .wrapper-channels .box-merged {
    grid-column-start: 1;
    grid-column-end: 3;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-right: 1px dotted #b3b3b3;
}

.card-channel-accomplishments .wrapper-channels .box-merged .variable-name {
    color: #605B63 !important;
    font-size: 12px;
    text-align: center;
    font-weight: bold;
    margin: 0px;
}
</style>
